module.exports = __webpack_public_path__ + "static/homepage-banner-6e59b38eef99d3c4b000cabfc2f15e84.png";